/**
 * Get the constructor Class name of the given value (works like the `$.type()` method)
 * @param value Value for which to get the type
 * @return The constructor Class name of the given value
 */
export default function typeOf(value: any): string {
  return Object.prototype.toString
    .call(value)
    .replace(/(^\[\w+ |\]$)/g, '')
    .toLowerCase();
}
